import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import docsThumb from "../../../assets/images/documentsPreview/docsthumb.png";
import xlxThumb from "../../../assets/images/documentsPreview/xlxthumb.png";
import videoThumb from "../../../assets/images/documentsPreview/videothumb.png";
import pdfThumb from "../../../assets/images/documentsPreview/pdfthumb.png";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import { Menu, Dropdown, Modal, Button, Select, Icon } from "antd";
import * as Style from "../../../newComponents/styledComponents/PersonalInstruction";
import copyLink from "../../../assets/images/copyIconWhite.svg";
import { modules } from "../moduleConstants";
import axios from "axios";
import swal from "sweetalert";
import "../importantDocument.css";
import searchIcon from "../../../assets/SVGs/magnify-glass-icon-grey.svg";
import { debounce } from "lodash";
const { Option } = Select;

export const ModuleDocuments = () => {
  const { moduleName } = useParams();
  const [moduleData, setModuleData] = useState([]);
  const [moduleModal, setModuleModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [shareModal, setShareModal] = useState(false);
  const [copied, setCopied] = useState(null);
  const [updateObject, setUpdateObject] = useState(null);
  const [timer, setTimer] = useState("");
  const [query, setQuery] = useState("");

  const cardsMainRef = useRef(null);
  const latestQueryRef = useRef("");

  const debouncedSearch = useMemo(() => {
    return debounce((searchText) => {
      latestQueryRef.current = searchText; // track latest valid search
      getModuleDocs(1, searchText, true);
    }, 500);
  }, []);

  useEffect(() => {
    const normalizedQuery = query.trim().replace(/\s+/g, " ");
    latestQueryRef.current = query;

    if (normalizedQuery.trim() === "") {
      // If query is empty, cancel any pending debounced call
      debouncedSearch.cancel();
      setModuleData([]);
      getModuleDocs(1, "", false); // fetch    default list
    } else {
      setModuleData([]);
      debouncedSearch(normalizedQuery); // debounced search
    }
  }, [query]);

  const handleChange = (e) => {
    const rawInput = e.target.value;

    const sanitized = rawInput.replace(/[^a-zA-Z0-9\s]/g, "");

    // Step 2: Replace multiple spaces with one (but NOT trimming yet, to allow natural typing)
    const singleSpaced = sanitized.replace(/\s{2,}/g, " ");

    setQuery(singleSpaced);
  };

  const handelCloseShareModal = () => {
    setShareModal(false);
    setCopied(null);
    setUpdateObject(null);
    setTimer("");
  };

  const handleShareDocument = async () => {
    const data = updateObject;
    console.log("updateObject", updateObject);
    if (updateObject.fileUrl !== null) {
      try {
        setLoading(true);
        let res = await DEATH_API.createSecureLink({
          link: updateObject.fileUrl,
          fileName: updateObject.fileName,
          shareWith: "TESTER",
          time: +timer,
        });
        setLoading(false);
        setCopied(res);
        console.log("res share documnet", res);
      } catch (error) {
        console.log(error);
        throw new Error(error);
      }
    } else {
      swal("Error", "You Have No File To Share", "error");
    }
  };

  const getFilePreview = (item) => {
    const fileType =
      item.fileName.split(".").pop().toLowerCase() ||
      extractFileNameFromUrl(item.fileUrl);
    switch (fileType) {
      case "png":
      case "jpg":
      case "jpeg":
        return (
          <img
            src={item.fileUrl}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "mp4":
      case "webm":
        return (
          <img
            src={videoThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "pdf":
        return (
          <img
            src={pdfThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "docx":
      case "doc":
        return (
          <img
            src={docsThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "xlsx":
      case "xls":
        return (
          <img
            src={xlxThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      case "csv":
        return (
          <img
            src={xlxThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
      default:
        return (
          <img
            src={docsThumb}
            alt={item.fileName}
            width={70}
            height={70}
            className="thumbnailDocs"
          />
        );
    }
  };
  const handleClick = (link) => {
    window.open(link, "blank");
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const getModuleDocs = async (
    page = 1,
    searchQuery = "",
    isFreshSearch = false
  ) => {
    try {
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        moduleName === "disasterDisability" ? "DISASTER" : moduleName,
        page,
        docsOTP,
        searchQuery
      );
      if (
        response &&
        response.status === 400 &&
        response.message !== "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
      }
      if (
        response &&
        response.status === 400 &&
        response.message === "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            fileUrl: item.fileUrl && item.fileUrl,
            cmId: item.cmId && item.cmId,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });

        setTotalPages(
          Math.ceil(response.data.count && response.data.count / 40)
        );
        setCurrentPage(page);
        // setModuleData((prevState) => [...prevState, ...allDocsData]);
        setModuleData((prevState) => {
          const merged = [...prevState, ...allDocsData];
          const duplicates = merged.filter(
            (item, index, self) =>
              index !== self.findIndex((i) => i.id === item.id)
          );
          // console.log("Duplicates removed11:", duplicates);
          const uniqueById = Array.from(
            new Map(merged.map((item) => [item.id, item])).values()
          );
          return uniqueById;
        });
        // setModuleData(newList);
        if (
          moduleName &&
          (moduleName.toLowerCase() === "assets" ||
            moduleName === "disasterDisability")
        ) {
          await getModuleCollection(page, searchQuery, isFreshSearch);
          await getModuleDisasterDisability(page, searchQuery, isFreshSearch)
        }
        // setModuleData(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };
  const getModuleDisasterDisability = async (
    page = 1,
    searchQuery = "",
    isFreshSearch = false
  ) => {
    try {
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        moduleName === "disasterDisability" ? "disasterDisability" : "collection",
        page,
        docsOTP,
        searchQuery
      );
      console.log("Docs listings==>", response);
      if (
        response &&
        response.status === 400 &&
        response.message !== "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
      }
      if (
        response &&
        response.status === 400 &&
        response.message === "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            fileUrl: item.fileUrl && item.fileUrl,
            cmId: item.cmId && item.cmId,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setTotalPages(
          Math.ceil(response.data.count && response.data.count / 40)
        );
        setCurrentPage(page);
        // setModuleData((prevState) => [...prevState, ...allDocsData]);
        setModuleData((prevState) => {
          const merged = [...prevState, ...allDocsData];
          const duplicates = merged.filter(
            (item, index, self) =>
              index !== self.findIndex((i) => i.id === item.id)
          );
          // console.log("Duplicates removed:", duplicates);
          const uniqueById = Array.from(
            new Map(merged.map((item) => [item.id, item])).values()
          );
          return uniqueById;
        });
        // setModuleData(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };
  const getModuleCollection = async (
    page = 1,
    searchQuery = "",
    isFreshSearch = false
  ) => {
    try {
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        moduleName === "disasterDisability" ? "DISABILITY" : "collection",
        page,
        docsOTP,
        searchQuery
      );
      console.log("Docs listings==>", response);
      if (
        response &&
        response.status === 400 &&
        response.message !== "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
      }
      if (
        response &&
        response.status === 400 &&
        response.message === "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        let allDocsData = response.data.rows.map((item) => {
          return {
            id: item.id,
            fileUrl: item.fileUrl && item.fileUrl,
            cmId: item.cmId && item.cmId,
            fileName:
              item.fileName ||
              (item.fileUrl && extractFileNameFromUrl(item.fileUrl)),
          };
        });
        setTotalPages(
          Math.ceil(response.data.count && response.data.count / 40)
        );
        setCurrentPage(page);
        // setModuleData((prevState) => [...prevState, ...allDocsData]);
        setModuleData((prevState) => {
          const merged = [...prevState, ...allDocsData];
          const duplicates = merged.filter(
            (item, index, self) =>
              index !== self.findIndex((i) => i.id === item.id)
          );
          // console.log("Duplicates removed:", duplicates);
          const uniqueById = Array.from(
            new Map(merged.map((item) => [item.id, item])).values()
          );
          return uniqueById;
        });
        // setModuleData(allDocsData);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };

  const handleInputChange = (name, value) => {
    setUserData({
      ...userData,
      [name]: value,
    });
  };
  const handleKeyPress = (event) => {
    console.log("submit");
    if (event.key === "Enter") {
      handleValidateOTP();
    }
  };
  const handleValidateOTP = async (event) => {
    console.log("submit");
    await getModuleDocs(currentPage);
  };
  const handleDeleteDocument = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        try {
          setLoading(true);
          let res = await MODULE_API.deleteModulesDocs(id);
          if (res && res.status === 200) {
            swal("Deleted!", "Your Document has been deleted.", "success");

            // Immediately remove the deleted item from state
            setModuleData((prev) => prev.filter((doc) => doc.id !== id));

            // Optionally update counts or refetch page 1 if needed
            if (moduleName && moduleName.toLowerCase() === "assets") {
              await getModuleCollection(1, query, true);
            }
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while deleting document", error);
        }
      }
    });
  };

  // const handleDeleteDocument = async (id) => {
  //   swal({
  //     title: "Are you sure?",
  //     text: "Are you sure you want to delete this ?",
  //     dangerMode: true,
  //     buttons: ["No, cancel it!", "Yes, delete it!"],
  //     icon: "warning",
  //     type: "warning",
  //     closeOnConfirm: false,
  //     closeOnCancel: false,
  //   }).then(async function (isConfirm) {
  //     // Redirect the user
  //     if (isConfirm) {
  //       try {
  //         setLoading(true);
  //         let res = await MODULE_API.deleteModulesDocs(id);
  //         if (res && res.status === 200) {
  //           swal("Deleted!", "Your Document has been deleted.", "success");
  //           await getModuleDocs(1, query, true);
  //           if (moduleName && moduleName.toLowerCase() === "assets") {
  //             await getModuleCollection(1,query,true);
  //           }
  //         }
  //         setLoading(false);
  //       } catch (error) {
  //         setLoading(false);
  //         console.log("error while updating User Defined", error);
  //       }
  //     }
  //   });
  // };
  const showModal = async () => {
    setIsModalOpen(true);
    try {
      let data = await DEATH_API.configOtp();
      if (data && data.message) {
        swal("Success", data.message, "success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const resenOTP = async () => {
    try {
      let data = await DEATH_API.configOtp();
      if (data && data.message) {
        swal("Success", data.message, "success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleCancel = () => {
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
    }
    setIsModalOpen(false);
  };
  useEffect(() => {
    // if (!localStorage.getItem("otp")) {
    //   localStorage.setItem("otp", "");
    //   showModal();
    // } else {
    if (moduleName) {
      getModuleDocs(1);
    }
    // }
  }, []);

  // useEffect(() => {
  //   if (moduleName) {
  //     getModuleDocs();
  //   }
  // }, []);

  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        fileName: name,
        fileUrl: res,
        type: moduleName,
      };
      handleSubmit(objToSubmit);
    }
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.uploadModulesDocs(body);
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      setModuleData([]);
      await getModuleDocs(1);
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };
  const handleOpenModuleModal = (docs) => {
    setModuleModal(true);
    setSelectedDocs(docs);
  };
  const handleCancelModuleModal = () => {
    setModuleModal(false);
    setSelectedDocs(null);
  };
  const hanldeModuleSelect = (selectedType) => {
    setModuleModal(false);
    if (selectedDocs && selectedDocs.cmId !== null) {
      swal(
        "Error",
        "You can not Move this Document this is already linked to module.",
        "error"
      );
      return;
    }
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to move this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, move it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let payload = {
            type: selectedType,
          };
          let res = await MODULE_API.moveModulesDocs(
            selectedDocs && selectedDocs.id,
            payload
          );
          if (res && res.status === 200) {
            swal("Success!", "Your Document has been Moved.", "success");
            setModuleData([]);
            await getModuleDocs(1);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while updating User Defined", error);
        }
      } else {
        swal("Cancelled", "Your Document is safe :)", "error");
      }
    });
    setSelectedDocs(null);
  };

  const handleScroll = () => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;

    if (scrollTop + clientHeight >= scrollHeight && currentPage < totalPages) {
      getModuleDocs(currentPage + 1, query);
    }
  };

  useEffect(() => {
    const element = cardsMainRef && cardsMainRef.current;
    if (!element) return;

    element.addEventListener("scroll", handleScroll);
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, totalPages]);

  return (
    <div className="reportsMain" style={{ position: "relative" }}>
      <div className="imp-docs-search-filter">
        <img
          src={searchIcon}
          alt="searchNewClientIcon"
          className="search-icon"
        />
        <input
          type="text"
          name="search"
          placeholder="Search Documents..."
          value={query}
          onChange={handleChange}
          onPaste={(e) => {
            e.preventDefault();
            const pasted = e.clipboardData
              .getData("text")
              .replace(/[^a-zA-Z0-9\s]/g, "")
              .replace(/\s{2,}/g, " ");
            setQuery(pasted);
          }}
        />
        {loading && <div>Loading....</div>}
      </div>
      <div className="reportcreate" style={{ justifyContent: "space-between" }}>
        <h3 className="selectHeadingMainDocs">
          Important Documents{" "}
          <span style={{ textTransform: "capitalize" }}>
            {moduleName === "disasterDisability"
              ? "Disaster and Disability"
              : moduleName === "liabilitiesandCredit"
              ? "Liabilities and Credit"
              : moduleName === "socialSecurity"
              ? "Social Security"
              : moduleName === "sourcesofIncome"
              ? "Source Of Income"
              : moduleName === "debtPayoff"
              ? "Debt Payoff"
              : moduleName}
          </span>
        </h3>
        <input
          type="file"
          id="image"
          name="image"
          onChange={handleImageUpload}
          style={{ display: "none" }}
        />
        <label
          className="addbuttonreport"
          htmlFor="image"
          style={{
            cursor: "pointer",
            pointerEvents:
              (!localStorage.getItem("otp") ||
                localStorage.getItem("otp") === "") &&
              "none",
            opacity:
              (!localStorage.getItem("otp") ||
                localStorage.getItem("otp") === "") &&
              "0.5",
          }}
        >
          Upload New
        </label>
      </div>
      <div className="documentGrid" ref={cardsMainRef}>
        {moduleData && moduleData.length > 0 ? (
          moduleData.map((item, index) => (
            <div
              title={item.fileName}
              key={index}
              className="documentCard"
              // onClick={() => {
              //   if (item.fileUrl) {
              //     handleClick(item.fileUrl);
              //   }
              // }}
            >
              {getFilePreview(item)}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "4px",
                  marginTop: "1rem",
                }}
              >
                <p
                  className="fileNameDocs"
                  style={{ margin: "0px" }}
                  title={item.fileName}
                >
                  {item.fileName.length > 20
                    ? `${item.fileName.substring(0, 17)}...`
                    : item.fileName}
                </p>
                <Dropdown
                  trigger={["click"]}
                  overlay={
                    <Menu>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            handleOpenModuleModal(item);
                          }}
                        >
                          Move
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            handleDeleteDocument(item.id);
                          }}
                        >
                          Delete
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            setShareModal(true);
                            setUpdateObject(item);
                          }}
                        >
                          Share
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            if (item.fileUrl) {
                              handleClick(item.fileUrl);
                            }
                          }}
                        >
                          View
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <a
                    className="ant-dropdown-link"
                    style={{ padding: "0px 8px" }}
                    onClick={(e) => e.preventDefault()}
                  >
                    <img
                      className="imgIcon"
                      src={menuIcon}
                      height={15}
                      width={4}
                      alt="icon"
                    ></img>
                  </a>
                </Dropdown>
              </div>
            </div>
          ))
        ) : (
          <div style={{ width: "100%", textAlign: "center" }}>
            <h2 style={{ marginTop: "6rem" }}>
              No data to show
            </h2>
          </div>
        )}
      </div>
      <Modal
        visible={moduleModal}
        footer={null}
        onCancel={handleCancelModuleModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Select Module Type For Moving Document</h3>
        <h3 className="modaltitle" style={{ fontSize: "12px" }}>
          Which Module would you like to move with?
        </h3>
        <h3 className="selectHeading">Select Module</h3>
        <div
          style={{
            maxHeight: "25rem",
            overflowY: "auto",
            background: "#F4F7FE",
          }}
        >
          <div className="selectmain" style={{ paddingInline: "8px" }}>
            {modules &&
              Object.values(modules)
                .flat()
                .map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      hanldeModuleSelect(item.name);
                    }}
                    className="selectMaincards"
                    style={{
                      width: "48%",
                      cursor: moduleName === item.name && "not-allowed",
                      pointerEvents: moduleName === item.name && "none",
                      opacity: moduleName === item.name && "0.5",
                    }}
                  >
                    <div className="selectMaincardsInner">
                      {" "}
                      <div
                        className="selectMainImages"
                        style={{ padding: "10px" }}
                      >
                        <img
                          src={item.image}
                          height={"25px"}
                          alt={item.title}
                        />{" "}
                      </div>
                      <div className="selectMainHeader">
                        <span
                          className="selectheadingValue"
                          style={{ fontSize: "12px" }}
                        >
                          {item.title}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelModuleModal();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal visible={isModalOpen} footer={null} closable={false} centered>
        <h3
          className="modaltitle"
          style={{ color: "#4d5e80", marginBottom: "10px" }}
        >
          {" "}
          Important Documents
        </h3>
        <div className="">
          <h2
            className="otp-heading"
            style={{ color: "#4d5e80", marginBottom: "10px" }}
          >
            This passcode provides another layer of security for your important
            documents. The passcode is only valid for this session.
          </h2>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Enter OTP</h3>
            <input
              className="roleInput"
              placeholder="***OTP***"
              name="otp"
              onKeyPress={handleKeyPress}
              // value={formData && formData.subCategoryName}
              id="otp"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.name, e.target.value);
              }}
            />
          </div>
          <Button
            onClick={() => {
              resenOTP();
            }}
          >
            Resend OTP
          </Button>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              // disabled={!formData || !formData.subCategoryName}
              onClick={() => {
                handleValidateOTP();
              }}
            >
              Save
            </button>
          </div>
        </div>
        <NewLoader isLoading={loading} />
      </Modal>

      {shareModal && (
        <Modal visible={shareModal} footer={null} closable={false} centered>
          <div>
            <Icon
              type="close"
              style={{
                cursor: "pointer",
                fontSize: "20px",
                color: "#2a3da3",
                float: "right",
              }}
              onClick={() => {
                handelCloseShareModal();
              }}
            />
            <h4 style={{ color: "#4d5e80", marginBottom: "10px" }}>
              {" "}
              {copied && copied.preSignedUrl
                ? "Secure Link Created"
                : "Share Document Name Using Secure Link"}
            </h4>

            <div className="">
              <div>
                {copied && copied.preSignedUrl ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Style.Input
                        style={{ width: "70%" }}
                        value={copied && copied.preSignedUrl}
                        disabled={true}
                      ></Style.Input>
                      <Style.SaveButton
                        style={{ width: "20%", height: "42px" }}
                        onClick={() => {
                          navigator.clipboard.writeText(copied.preSignedUrl);
                          console.log("cooppues");
                          handelCloseShareModal();
                          swal("Success", "Copied", "success");
                        }}
                      >
                        <img
                          src={copyLink}
                          alt="copy"
                          height={25}
                          width={30}
                        ></img>
                      </Style.SaveButton>
                    </div>
                    {copied && copied.preSignedUrl && (
                      <Style.WrapperButtons>
                        <Style.CancelButton
                          onClick={() => {
                            handelCloseShareModal();
                          }}
                        >
                          Cancel
                        </Style.CancelButton>
                        <Style.SaveButton
                          onClick={() => {
                            navigator.clipboard.writeText(copied.preSignedUrl);
                            console.log("cooppues");
                            handelCloseShareModal();
                            swal("Success", "Copied", "success");
                          }}
                        >
                          Done
                        </Style.SaveButton>
                      </Style.WrapperButtons>
                    )}
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      Secure Link becomes inactive (expires) after:
                    </div>
                    <Select
                      showSearch
                      placeholder="-Select-"
                      onChange={(value) => {
                        console.log("value", value);
                        setTimer(value);
                      }}
                    >
                      <Option value="3600">One Hour</Option>
                      <Option value="86400">One Day</Option>
                      <Option value="604800">One Week</Option>
                    </Select>
                  </>
                )}
                {copied && copied.preSignedUrl ? null : (
                  <Style.WrapperButtons>
                    <Style.CancelButton
                      onClick={() => {
                        handelCloseShareModal();
                      }}
                    >
                      Cancel
                    </Style.CancelButton>
                    <Style.SaveButton
                      onClick={() => {
                        handleShareDocument();
                      }}
                    >
                      Create Link
                    </Style.SaveButton>
                  </Style.WrapperButtons>
                )}
              </div>
            </div>
          </div>
          <NewLoader isLoading={loading} />
        </Modal>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
